// Split out of config.ts to break a circular import: config.ts pulls in every ProjectForm page
// component, some of which need this enum's values at module-eval time. Import it from here, not
// ./config, to avoid pulling in config.ts's page-component graph.
export enum EProjectFormPages {
    DEAL_TYPE_TEMPLATE = "Deal Type & Template",
    ACCOUNT_N_LOCATION = "Account & Site",
    PROJECT_DETAILS = "Project Details",
    MATERIAL_DETAILS = "Material Details",
    INFRA_DETAILS = "Infra Details",
    SAAS_DETAILS = "SaaS Details",
    LAND_DETAILS = "Land Details",
    ADD_ONS = "Add Ons",
    PAYMENT_DETAILS = "Payment Details",
    ON_GROUND_POC = "On-ground POC",
}
